import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import * as signalR from '@microsoft/signalr';
import { fetchActiveScanJobs } from '../api/receiptsApi';

const HUB_URL = `${import.meta.env.VITE_API_URL}/hub/liverefresh`;

// Mirrors useExpensesByJob — scoped React Query + SignalR invalidation, but
// listens to UpdateScanJobs (banner state transitions) instead of the
// expense/receipt fires. Returns Queued/Processing rows + the trailing 30
// days of Failed rows for the active job; the banner derives "any in
// flight?" + the failed-rows list from the same payload.
export default function useActiveScanJobs(jobId) {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['scanJobs', jobId],
        queryFn: () => fetchActiveScanJobs(jobId),
        enabled: jobId != null,
        retry: false,
    });

    useEffect(() => {
        if (jobId == null) return undefined;

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(HUB_URL, {
                accessTokenFactory: () =>
                    window.Clerk.session.getToken({ template: 'marginpal-api' }),
            })
            .withAutomaticReconnect()
            .build();

        const invalidate = () =>
            queryClient.invalidateQueries({ queryKey: ['scanJobs', jobId] });

        connection.on('UpdateScanJobs', invalidate);

        connection.start().catch(err => console.error('SignalR connection error:', err));

        return () => {
            connection.stop();
        };
    }, [queryClient, jobId]);

    return query;
}
